import dayjs, { Dayjs } from 'dayjs';
import { DurationType } from 'src/Enum/GoalsAndOperationalPlans';
import { IGoalFormValues } from '@Router/GoalAndOperationalPlans/Containers/GoalAndOperationalPlansFormProvider/types';

export const durationOptions = [
  { label: 'ช่วงเดือน / ปี', value: DurationType.MONTH_PERIOD },
  { label: 'ภายใน (เดือน / ปี)', value: DurationType.WITHIN_MONTH },
];

export const formatMonthYearEn = (date: Dayjs | null): string | null => {
  if (!date) return null;
  return date?.locale('en').format('MMMM YYYY');
};

export const setDateToFirst = (date: Dayjs | undefined | null) => {
  if (!date) return null;
  return dayjs(date).set('date', 1);
};

export const mapGoalFormValue = (data: IGoalFormValues): IGoalFormValues => {
  return {
    ...data,
    startDate: data.startDate ? dayjs(data.startDate) : null,
    endDate: dayjs(data.endDate),
  };
};

export const createNewGoal = (data: IGoalFormValues) => {
  return {
    detailTh: data.detailTh,
    detailEn: data.detailEn,
    durationType: data.durationType,
    startDate: setDateToFirst(data.startDate),
    endDate: setDateToFirst(data.endDate),
    indicators: data.indicators || [],
  };
};
